//
// Copyright (c) 2020 Astute Global, Inc.
//

define(["marionette", "./template/tableOfContentsTemplate.html"], function (
  Marionette,
  TableOfContentsTemplate,
) {
  var TableOfContentsView = {};

  TableOfContentsView.tableOfContentsView = Marionette.Layout.extend({
    template: TableOfContentsTemplate,
    triggers: {
      "click #addTableOfContents": "add:tableOfContents",
    },
    regions: {
      tableOfContentsEntry: ".table-of-contents-entry",
      tableOfContentsList: ".table-of-contents-list",
    },
  });

  return TableOfContentsView;
});
